<template>
    <div class="content" v-loading="pageLoading">
        <div class="content-bgc">
            <img class="content-img" :src="bigImgInfo.project" alt="" />
            <div class="content-txt">
                <div class="content-e">Cases</div>
                <div class="content-c">项目中心</div>
            </div>
        </div>
        <div class="list-view">
            <div class="list-item-two" v-for="(item, index) in pageList" :key="index">
                <img class="list-one-img" :src="item.image" alt="" />
                <div class="list-left">
                    <div class="title">{{ item.projectName }}</div>
                    <div class="text-view" style="margin-top: 20px;">
                        <label class="text-key">地理位置：</label>
                        <label class="text-value">{{ item.address }}</label>
                    </div>
                    <div class="text-view" style="margin-top:8px;">
                        <label class="text-key">项目概况：</label>
                        <label class="text-value">{{ item.projectSituation }}</label>
                    </div>
                    <div class="text-view" style="margin-top:8px;">
                        <label class="text-key">园区业态：</label>
                        <label class="text-value">{{ item.commercialForm }}</label>
                    </div>
                    <div class="line"></div>
                    <div class="num-view">
                        <div class="nun-item">
                            <div class="num-name">园区升级改造投入</div>
                            <div class="num-n">
                                <span>
                                    <animate-number :key="index" from="0" :to="item.updateFee" duration="10000"
                                        easing="easeOutQuad" />
                                </span>万元
                            </div>
                        </div>
                        <div class="nun-item">
                            <div class="num-name">年营业额达</div>
                            <div class="num-n">
                                <span>
                                    {{ item.turnover }}</span>亿元
                            </div>
                        </div>
                        <div class="nun-item">
                            <div class="num-name">{{ item.taxPayableYear }}年度产税</div>
                            <div class="num-n">
                                <span>
                                    <animate-number :key="index" from="0" :to="item.taxPayable" duration="10000"
                                        easing="easeOutQuad" /></span>万元
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-empty description="暂无数据" v-if="!pageLoading && !pageList.length"></el-empty>
        <div class="pagination-view">
            <pagination :page.sync="page" :pageSize="2" :total="total" @change="pageChange" />
        </div>
    </div>
</template>

<script>
import bigImgMixin from "../mixins/bigImgMixin.js";
import Pagination from '../components/PaginationTree.vue'
export default {
    mixins: [bigImgMixin],
    components: { Pagination },
    data() {
        return {
            pageLoading: true,
            page: 1,
            total: 0,
            pageList: [],
        };
    },
    created() {
    },
    mounted() {
        const query = this.$route.query;
        this.page = +query.page || 1;
        this.getProjectApi();
    },
    methods: {
        // 项目中心  
        async getProjectApi() {
            try {
                const res = await this.$get('/api/other/project', {
                    page: this.page
                });
                this.pageList = (res.data.data || []).map(item => {
                    return { ...item }
                });
                this.total = res.data.total || 0;
                console.warn(res, this.pageList, "项目中111心")
            } catch (error) {
                console.error('Error fetching basic config:', error);
            }
            this.pageLoading = false;
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/center?page=${this.page}`);
            this.getProjectApi();
        },
    },
};  
</script>

<style lang="scss" scoped>
.content {
    background: #F5F5F5;
}


.content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .list-view {
        margin-top: 52px;
        width: 1400px;

        .list-item-two {
            margin-top: 48px;
            display: flex;

            .list-left {
                width: 740px;
                height: 450px;
                background: #FFFFFF;
                border-radius: 0 0 30px 0;
                padding: 60px 80px;

                .line {
                    margin-top: 75px;
                    width: 100%;
                    height: 0px;
                    border: 1px dashed #e8e8e8;
                }

                .num-view {
                    margin-top: 24px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .nun-item {
                        width: 33%;

                        .num-name {
                            font-size: 14px;
                            font-family: Microsoft YaHei, Microsoft YaHei-400;
                            font-weight: 400;
                            color: #999999;
                        }

                        .num-n {
                            margin-top: 8px;
                            font-size: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei-700;
                            font-weight: 700;
                            color: #222222;

                            span {
                                margin-right: 4px;
                                font-size: 36px;
                                font-family: Montserrat, Montserrat-600;
                                font-weight: 600;
                                color: #b18148;
                            }
                        }
                    }
                }

                .title {
                    font-size: 44px;
                    font-family: Microsoft YaHei, Microsoft YaHei-700;
                    font-weight: 700;
                    color: #222222;
                }

                .text-view {
                    line-height: 25px;

                    .text-key {
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-400;
                        font-weight: 400;
                        color: #b18148;
                    }

                    .text-value {
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-400;
                        font-weight: 400;
                        color: #222222;
                    }
                }

                .mark {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    /*控制在3行*/
                    -webkit-line-clamp: 9;
                    -webkit-box-orient: vertical;
                    // height: 240px;
                    line-height: 25px;
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-400;
                    font-weight: 400;
                    color: #222222;
                    margin-top: 32px;
                }
            }

            .list-one-img {
                width: 660px;
                height: 450px;
                border-radius: 30px 0 0 0;

            }
        }

        .list-item-one {
            margin-top: 48px;
            display: flex;

            .list-left {
                width: 740px;
                height: 450px;
                background: #FFFFFF;
                border-radius: 30px 0 0 0;
                padding: 60px 80px;

                .title {
                    font-size: 44px;
                    font-family: Microsoft YaHei, Microsoft YaHei-700;
                    font-weight: 700;
                    color: #222222;
                }

                .mark {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    /*控制在3行*/
                    -webkit-line-clamp: 9;
                    -webkit-box-orient: vertical;
                    // height: 240px;
                    line-height: 25px;
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-400;
                    font-weight: 400;
                    color: #222222;
                    margin-top: 32px;
                }
            }

            .list-one-img {
                width: 660px;
                height: 450px;
                border-radius: 0 0 30px 0;
            }
        }
    }

    .pagination-view {
        margin-top: 48px;
        margin-bottom: 100px;
    }

    .content-bgc {
        width: 100%;
        height: 700px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content-img {
            height: 100%;
            width: 100%;
        }

        .content-txt {
            display: inline-block;
            /* 防止内容撑破容器 */
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /* 相对于自身宽高的50%进行移动，实现居中 */
            width: 1400px;

            .content-e {
                font-size: 28px;
                font-family: Montserrat, Montserrat-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }

            .content-c {
                margin-top: 10px;
                font-size: 54px;
                font-family: Microsoft YaHei, Microsoft YaHei-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }
        }
    }
}
</style>
